var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameGridLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5316 5.54468C13.4793 5.54468 12.8914 6.55151 13.1309 7.29964L10.5546 9.78874C10.3368 9.72582 10.0175 9.72582 9.7998 9.78874L7.94917 8.00582C8.19592 7.25769 7.60807 6.24386 6.54849 6.24386C5.49617 6.24386 4.90107 7.25069 5.14782 8.00582L1.83845 11.1871C1.06191 10.9564 0.0168457 11.5227 0.0168457 12.5365C0.0168457 13.3057 0.67001 13.9349 1.46832 13.9349C2.52064 13.9349 3.10849 12.9281 2.869 12.18L6.17111 8.99167C6.38883 9.0546 6.70815 9.0546 6.92588 8.99167L8.77651 10.7746C8.52976 11.5227 9.11761 12.5365 10.1772 12.5365C11.2295 12.5365 11.8246 11.5297 11.5779 10.7746L14.1615 8.29248C14.938 8.52321 15.9831 7.95687 15.9831 6.94305C15.9831 6.17395 15.3299 5.54468 14.5316 5.54468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1772 6.24395L10.8594 4.79663L12.3544 4.14639L10.8594 3.49615L10.1772 2.04883L9.5095 3.49615L7.99997 4.14639L9.5095 4.79663L10.1772 6.24395ZM1.83119 7.64232L2.19406 6.24395L3.64554 5.89436L2.19406 5.54476L1.83119 4.14639L1.46832 5.54476L0.0168457 5.89436L1.46832 6.24395L1.83119 7.64232Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameGridLogoSmall);
export default __webpack_public_path__ + "static/media/gameGridLogoSmall.37fe388287b30b30fa15acd68fc9d109.svg";
export { ForwardRef as ReactComponent };